function addGlobalEventListener(
  type,
  selector,
  cb,
  options,
  parent = document
) {
  parent.addEventListener(
    type,
    (e) => {
      let el = getClosest(selector, e.target);

      if (el) {
        e.preventDefault();
        cb(el);
      }
    },
    options
  );
}

function qs(selector, parent = document) {
  return parent.querySelector(selector);
}

function qsa(selector, parent = document) {
  return [...parent.querySelectorAll(selector)];
}

function getClosest(selector, el) {
  if (el.matches(selector)) {
    return el;
  } else {
    return el.closest(selector);
  }
}

class Selector {
  constructor(options) {
    this.options = options;
    this.selector = qs(options.id);

    if (!this.selector) return;

    this.dropdown = qs('.js-selector__dropdown', this.selector);
    this.popup = qs('.js-selector__popup', this.selector);
    this.button = qs('.js-selector__popup-button', this.selector);
    this.select = qs('.js-selector__popup-select', this.selector);
    this.value = qs('.js-selector__value', this.selector);
    this.icon = qs('.js-selector__icon', this.selector);
    this.active = false;

    if (this.dropdown) {
      this.items = qsa('.js-selector__item', this.dropdown);
    }

    this.init();
  }

  init() {
    this.selector.addEventListener('click', (e) => {
      let isDropdown = getClosest('.js-selector__dropdown', e.target);
      let isPopup = getClosest('.js-selector__popup-container', e.target);
      let isClose = getClosest('.js-selector__popup-close', e.target);
      let isUpdate = getClosest('.js-selector__popup-button', e.target);
      if (isClose || isUpdate || isDropdown || (!isPopup && this.active)) {
        this.hide();
      } else {
        this.show();
      }
    });

    if (this.items) {
      this.items.forEach((item) => {
        item.addEventListener('click', () => {
          this.selectItem(item.innerText);

          if (item.dataset.url) {
            window.location.href = item.dataset.url;
          }
        });
      });
    }

    if (this.button) {
      this.button.addEventListener('click', () => {
        this.selectItem(this.select.value);
      });
    }

    document.addEventListener('click', (e) => {
      if (
        !e.target.matches(this.options.id) &&
        !e.target.closest(this.options.id)
      ) {
        if (this.active) {
          this.hide(true);
        }
      }
    });
  }

  show() {
    this.active = true;

    if (this.dropdown) {
      this.dropdown.classList.add('selector__dropdown--active');
    }

    if (this.popup) {
      this.popup.classList.add('selector__popup--active');
    }
  }

  hide() {
    this.active = false;

    if (this.dropdown) {
      this.dropdown.classList.remove('selector__dropdown--active');
    }

    if (this.popup) {
      this.popup.classList.remove('selector__popup--active');
    }
  }

  selectItem(item) {
    this.value.dataset.flag = `#${item}`;
    this.value.innerText = item;

    let icon = qs('use', this.icon);
    console.log(icon.setAttribute('href', this.value.dataset.flag));

    if (this.options.onChange) {
      this.options.onChange(item);
    }

    this.hide();
  }
}
 
function scrollLock(lock = true) {
  if (lock) {
    const html = document.querySelector('html');
    const scrollY =
    document.documentElement.style.getPropertyValue('--scroll-y');
    html.classList.add('html--locked');
    html.style.top = `-${scrollY}`;
    setTimeout(() => {
      document.documentElement.style.setProperty('--scroll-y', `${scrollY}`);
    }, 100)
  } else {
    const html = document.querySelector('html');
    const scrollY = html.style.top;
    html.classList.remove('html--locked');
    html.style.top = '';
    setTimeout(() => {
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    });
  }
}

function isDesktop() {
  let breakpoint = window.matchMedia('(min-width: 990px)');
  return breakpoint.matches;
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function interpolate(str, params) {
  let names = Object.keys(params);
  let vals = Object.values(params);
  return new Function(...names, `return \`${str}\`;`)(...vals);
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function formatVideoTime(s) {
  let m = Math.floor(s / 60);
  m = (m >= 10) ? m : "0" + m;
  s = Math.floor(s % 60);
  s = (s >= 10) ? s : "0" + s;
  return m + ":" + s;
}